import { BREAKPOINTS } from 'constants/breakpoints';
import React, { useEffect, useState } from 'react';
import useWindowSize from 'hooks/useWindowSize';
const BrowserContext = React.createContext({
    isMobile: true,
    isSafari: false,
});
const BrowserConsumer = BrowserContext.Consumer;
/**
 * This context is here to store the Server Side value of checking if the device is mobile or not and if the browser is Safari or not.
 */
const BrowserProvider = ({ children, isMobileServerSide, isSafariServerSide, }) => {
    const [isMobile, setIsMobile] = useState(true);
    const [isSafari, setIsSafari] = useState(false);
    const { width } = useWindowSize();
    useEffect(() => {
        const newIsMobile = isMobileServerSide !== undefined
            ? String(isMobileServerSide) === 'true'
            : width < BREAKPOINTS.mobile;
        if (isMobile !== newIsMobile) {
            setIsMobile(newIsMobile);
        }
    }, [isMobileServerSide, width]);
    useEffect(() => {
        const newIsSafari = isSafariServerSide !== undefined
            ? String(isSafariServerSide) === 'true'
            : false;
        if (isSafari !== newIsSafari) {
            setIsSafari(newIsSafari);
        }
    }, [isSafariServerSide]);
    return (React.createElement(BrowserContext.Provider, { value: { isMobile, isSafari } }, children));
};
export { BrowserProvider, BrowserConsumer };
export default BrowserContext;
